import { FC } from 'react';
import { Control } from 'react-hook-form';
import { Row } from 'further-ui/components/Layout';
import FormField from 'further-ui/components/FormField';
import { Controller } from 'react-hook-form';
import Switch from 'further-ui/components/Switch';
import { BulletinUpdateFormValues } from '../schema';

type Props = {
  control: Control<BulletinUpdateFormValues>;
};

const UkFinancialPromotionNotice: FC<Props> = ({ control }) => {
  return (
    <Controller
      control={control}
      name="includeUkFinancialPromotionsNotice"
      render={({ field }) => (
        <Row spacing="sm" centered>
          <FormField
            label="Include UK financial promotions notice"
            tooltip="Turning this on will add UK FCA COBS financial promotion wording in a box at the top of your email."
          />
          <Switch checked={field.value} onChange={field.onChange} />
        </Row>
      )}
    />
  );
};

export default UkFinancialPromotionNotice;
